import { UserPreferencesConfig } from 'softcat:config/user-preferences.ts';
import { SoftcatApiWidget } from 'softcat:types/softcat-api.ts';
import { SearchParameterUtils } from 'softcat:utils/search-parameters.ts';
import { SoftcatApiUtils } from 'softcat:utils/softcat-api.ts';

const create = async (data: File): Promise<SoftcatApiWidget> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    const form = new FormData();
    form.append('file', data);
    form.append('territory', `${territory}`);

    return SoftcatApiUtils.post<SoftcatApiWidget>(`/widgets?${parameters}`, { body: form });
};

const findAll = async ({
    latest = false,
    limit = 10,
    page = 0,
    query = '',
    orderBy = '',
}: { latest?: boolean; limit?: number; orderBy?: string; page?: number; query?: string } = {}): Promise<SoftcatApiWidget[]> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(
        SearchParameterUtils.removeEmptySearchParameters({
            filter: `territory=${territory}${query ? `,id==*${query}*` : ''}`,
            latest: `${latest ? 'true' : ''}`,
            limit: `${limit}`,
            offset: `${page}`,
            orderBy: `${orderBy}`,
            territory: `${territory}`,
        }),
    );

    return SoftcatApiUtils.get<SoftcatApiWidget[]>(`/widgets?${parameters}`);
};

const findOne = async ({ id, version }: { id: string; version: string }): Promise<SoftcatApiWidget> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.get<SoftcatApiWidget>(`/widgets/${id}/${version}?${parameters}`);
};

const remove = async ({ id, version }: { id: string; version: string }): Promise<void> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.remove(`/widgets/${id}/${version}?${parameters}`);
};

const sign = async ({ file, id, password, version }: { file: File; id: string; password: string; version: string }): Promise<SoftcatApiWidget> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    const form = new FormData();
    form.append('file', file);
    form.append('password', password);

    return SoftcatApiUtils.post<SoftcatApiWidget>(`/widgets/action/sign/${id}/${version}?${parameters}`, { body: form });
};

const update = async (data: Partial<SoftcatApiWidget>): Promise<SoftcatApiWidget> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.put<SoftcatApiWidget>(`/widgets/${data.id}/${data.version}?${parameters}`, { body: data });
};

export const WidgetService = {
    create,
    findAll,
    findOne,
    remove,
    sign,
    update,
};
